import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Http } from "@angular/http";
import { Injectable } from "@angular/core";
import { BaseService } from "../services/base.service";

@Injectable()
export class SearchGuard extends BaseService implements CanActivate {
  constructor(protected http: Http, private router: Router) {
    super(http);
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      if (route.queryParams && route.queryParams.redirectTo) {
        this.router.navigate([route.queryParams.redirectTo]);
        return true;
      }
      const userRole = await this.get("userRole");
      if (
        ["admin", "researcher", "qc", "technician", "grader"].includes(userRole)
      ) {
        return true;
      } else {
        this.router.navigate(["/login"]);
        return false;
      }
    } catch (err) {
      this.router.navigate(["/login"]);
      return false;
    }
  }
}
``;



// WEBPACK FOOTER //
// ./src/app/home/search-guard.service.ts